/**
 * RobinhoodSpace contact support — Firestore tickets (newone-f340f).
 */
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebaseconfig';

export async function submitSupportTicket({ name, email, message }) {
  if (!db) {
    throw new Error('Support is unavailable (Firebase not configured).');
  }
  const user = auth?.currentUser;
  await addDoc(collection(db, 'supportTickets'), {
    name: String(name || '').trim(),
    email: String(email || '').trim(),
    message: String(message || '').trim(),
    userId: user?.uid || null,
    userEmail: user?.email || null,
    status: 'open',
    source: 'robinhoodspace-cra',
    createdAt: serverTimestamp(),
  });
}
